// Allow for runtime configuration via the window.env object
const kcUrl = `${window.env.keycloak?.url}`;
const kcRealm = `${window.env.keycloak?.realm}`;
const kcClient = `${window.env.keycloak?.client}` || 'patient-portal';

const kcConfig = {
  realm: `${kcRealm}`,
  url: `${kcUrl}`,
  resource: `${kcClient}`,
  clientId: `${kcClient}`,
  'ssl-required': 'external',
  'public-client': true,
  'confidential-port': 0,
};

export default kcConfig;
